module.exports = __webpack_public_path__ + "images/feature/feature_1027_3-0c6ae82721a4b0fa1220fb3db545827d.png";